import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import AlertBanner from '@/components/common/AlertBanner/alert-banner.vue'

@Component({
    components: {
        AlertBanner
    }
})
export default class ActivityConceptsModalBasicForm extends Vue {
    @Ref() readonly activityConceptsModalBasicForm!: any

    @Prop(String) readonly actionTitle!: string

    show() {
        this.activityConceptsModalBasicForm.show()
    }

    hide() {
        this.activityConceptsModalBasicForm.hide()
    }
}
